export default "__VITE_ASSET__CLN2tUXA__"